import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';
import { INCIDENTS_TABS } from './i18n.incidents';

const IncidentsView = lazy(
  () =>
    import(
      /* webpackChunkName: "IncidentManagementRoutes" */ './IncidentsTableDisplay'
    )
);

export const incidentsRoutes: PageRouter[] = [
  {
    name: INCIDENTS_TABS.ACTIVE,
    path: `/${INCIDENTS_TABS.ACTIVE}`,
    component: IncidentsView,
    exact: false,
    tabs: []
  },
  {
    name: INCIDENTS_TABS.ARCHIVED,
    path: `/${INCIDENTS_TABS.ARCHIVED}`,
    component: IncidentsView,
    exact: false,
    tabs: []
  }
];
